import React, {
  createContext,
  useContext,
  useEffect,
} from "react"
// import * as amplitude from '@amplitude/analytics-browser'


const defaults = {}

const AnalyticsContext = createContext(defaults)
const AnalyticsContextProvider = AnalyticsContext.Provider

type PropsProvider = {
  children: JSX.Element
}

import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react"
import { trackEvent } from "../helpers/tracker"

const growthbook = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-vBTpmY8EiAyNeX3",
  enableDevMode: true,
  onFeatureUsage: (experiment, result) => {
    // TODO: Use your real analytics tracking system
    console.log("🚀 Viewed FEature", {
      experimentId: experiment,
      variationId: result.value
    })
    if (result.value !== null) {
      trackEvent(`abtesting:${result.value ? 'new-home' : 'old-home'}`)
    }
  }
})

const generateUniqueId = () => {
  // Intentamos obtener el identificador único del navegador (si es compatible)
  let uniqueId = localStorage.getItem('browserUniqueId')

  if (uniqueId) {
    // Si tenemos un identificador único almacenado en el localStorage, verificamos si ha expirado
    const item = JSON.parse(uniqueId)
    const now = new Date().getTime()

    if (item.expiry > now) {
      console.log("obtenido de localstorage")
      return item.value // El identificador aún es válido, lo retornamos
    }
    console.log("Expiro id, generando")
    // El identificador ha expirado, lo eliminamos
    localStorage.removeItem('browserUniqueId')
  }

  // Generamos un nuevo identificador único
  const timestamp = new Date().getTime()
  const randomValue = Math.random().toString(36).substr(2, 10)
  uniqueId = `${timestamp}-${randomValue}`

  // Almacenamos el identificador único con expiración en localStorage
  const expirationInSeconds = 30 * 24 * 60 * 60 // 30 días en segundos
  setWithExpiry('browserUniqueId', uniqueId, expirationInSeconds)

  return uniqueId
}

const setWithExpiry = (key: string, value: string, expiryInSeconds: number) => {
  const now = new Date()
  const item = {
    value: value,
    expiry: now.getTime() + expiryInSeconds * 1000 // Convertir segundos a milisegundos
  }
  localStorage.setItem(key, JSON.stringify(item))
}

const AnalyticsProvider = ({ children }: PropsProvider) => {

  useEffect(() => {
    // Load features asynchronously when the app renders
    growthbook.loadFeatures()
    growthbook.setAttributes({
      id: generateUniqueId(),
    })

    // const initAmplitude = async () => {
    //   await amplitude.init("eb8b1dd87076ff8c792ac39ceacbc2c7", {
    //     serverUrl: 'https://g5ra0wepsa.execute-api.us-east-2.amazonaws.com/v2'
    //   }).promise
    // }

    // initAmplitude()
  }, [])

  return (
    <AnalyticsContextProvider value={{}}>
      <GrowthBookProvider growthbook={growthbook}>
        {children}
      </GrowthBookProvider>
    </AnalyticsContextProvider>
  )
}

const useAnalytics = () => {
  const context = useContext(AnalyticsContext)
  if (context === undefined) {
    throw new Error("useAnalytics must be used within a AnalyticsProvider")
  }
  return context
}

export {
  AnalyticsProvider,
  useAnalytics,
}
